import * as Sentry from "@sentry/react";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import { setLocalStorage, removeLocalStorage } from "utils/storageUtil";

const CHECKOUT_KEY = "checkoutIdempotencyKey";

// Backend requires the key to end with a 13 digit epoch ms timestamp.
const generateKey = () => {
  const random =
    window.crypto?.randomUUID?.() ||
    `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  return `${random}-${Date.now()}`;
};

export const getCheckoutKey = () => {
  try {
    return JSON.parse(localStorage.getItem(CHECKOUT_KEY)) || null;
  } catch (e) {
    return null;
  }
};

export const getOrCreateCheckoutKey = () => {
  const existing = getCheckoutKey();
  if (existing) return existing;

  const key = generateKey();
  setLocalStorage(CHECKOUT_KEY, key);
  return key;
};

export const clearCheckoutKey = () => {
  removeLocalStorage(CHECKOUT_KEY);
};

export const cancelCheckout = async (orderId, reason) => {
  const idempotencyKey = getCheckoutKey();
  if (!orderId && !idempotencyKey) return true;

  const apiUrl = orderId
    ? apiList.payment.cancel
    : apiList.payment.cancelByKey;
  const body = orderId ? { orderId } : { idempotencyKey, reason };

  try {
    const apiResponse = await callApi.patch(apiUrl, body);
    const isCancelled = [200, 202].includes(apiResponse?.status);
    if (isCancelled) clearCheckoutKey();
    return isCancelled;
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setTag("flow", "payment_cancel");
      scope.setContext("request", { url: apiUrl, orderId, idempotencyKey });
      scope.captureException(e);
    });
    console.log(e);
    return false;
  }
};
